import React, { ChangeEvent } from 'react';
import styles from 'views/Profile/components/Dropdown/Dropdown.module.css';
import { DropdownProps } from 'views/Profile/components/Dropdown/Dropdown.types';

const Dropdown = ({
  options,
  onChange,
  value,
  disable = false,
  className,
  placeholder,
}: DropdownProps) => {
  const dropdownOnchangeHandler = (e: ChangeEvent<HTMLSelectElement>) => {
    onChange(e.target.value);
  };

  return (
    <select
      className={`${styles.dropdown} ${className || ''}`}
      onChange={(e) => dropdownOnchangeHandler(e)}
      value={value}
      disabled={disable}
    >
      {placeholder && (
        <option value="" disabled>
          {placeholder}
        </option>
      )}
      {options.map((i) => (
        <option key={i.value} value={i.value}>
          {i.label}
        </option>
      ))}
    </select>
  );
};

export default Dropdown;
